import { render, staticRenderFns } from "./QuantityCell.vue?vue&type=template&id=4b560038&"
import script from "./QuantityCell.vue?vue&type=script&lang=js&"
export * from "./QuantityCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports